export function detectOS() {
  const userAgent = window.navigator.userAgent;
  
  if (userAgent.includes("Windows")) {
    return "Windows";
  } else if (userAgent.includes("Mac")) {
    return "Mac OS";
  } else if (userAgent.includes("Linux")) {
    return "Linux";
  } else if (userAgent.includes("Android")) {
    return "Android";
  } else if (userAgent.includes("iOS")) {
    return "iOS";
  } else {
    return "Unknown";
  }
}